import React, { createContext, useContext, useState } from "react";
import {
  IPatient,
  IPatientInsurance,
  IPatiendCalendar,
  IPatientTime,
  IPatientInfo,
  IPatientContinuidad,
  IPatientInformation
} from "../../interfaces/Patient";
import { IHorariosDisponibles } from "../../interfaces/Services";

type DataContextType = {
  data: IPatient[];
  setData: React.Dispatch<React.SetStateAction<IPatient[]>>;

  data2: IPatientInsurance[];
  setData2: React.Dispatch<React.SetStateAction<IPatientInsurance[]>>;

  CalendarData: IPatiendCalendar[];
  setCalendarData: React.Dispatch<React.SetStateAction<IPatiendCalendar[]>>;

  TimeData: IPatientTime[];
  setTimeData: React.Dispatch<React.SetStateAction<IPatientTime[]>>;

  HorariosData: IHorariosDisponibles;
  setHorariosData: React.Dispatch<React.SetStateAction<IHorariosDisponibles>>;

  patientInfoContinuidadContex: IPatientInfo | null;
  setPatientInfoContinuidadContex: React.Dispatch<React.SetStateAction<IPatientInfo | null>>;

  patientContinuidadContex: IPatientContinuidad | null;
  setPatientContinuidadContex: React.Dispatch<React.SetStateAction<IPatientContinuidad | null>>;

  patientInformationContext: IPatientInformation | null ;
  setPatientInformationContext: React.Dispatch<React.SetStateAction<IPatientInformation | null>>;
};

type DataProviderProps = {
  children: React.ReactNode;
};
const DataContext = createContext<DataContextType | undefined>(undefined);

export const PatientProvider: React.FC<DataProviderProps> = ({ children }) => {
  const [data, setData] = useState<IPatient[]>([]);
  const [data2, setData2] = useState<IPatientInsurance[]>([]);
  const [CalendarData, setCalendarData] = useState<IPatiendCalendar[]>([]);
  const [TimeData, setTimeData] = useState<IPatientTime[]>([]);
  const [patientInformationContext, setPatientInformationContext] = useState<IPatientInformation | null>(null);

  const [patientInfoContinuidadContex, setPatientInfoContinuidadContex] = useState<IPatientInfo | null>(null);

  const [patientContinuidadContex, setPatientContinuidadContex] = useState<IPatientContinuidad | null>(null);

  const [HorariosData, setHorariosData] = useState<IHorariosDisponibles>({
    data: [],
  });
  return (
    <DataContext.Provider
      value={{
        data,
        setData,
        data2,
        setData2,
        CalendarData,
        setCalendarData,
        TimeData,
        setTimeData,
        HorariosData,
        setHorariosData,
        patientInfoContinuidadContex,
        setPatientInfoContinuidadContex,
        patientContinuidadContex,
        setPatientContinuidadContex,
        patientInformationContext,
        setPatientInformationContext,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useDataContex = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};
